// Generated by CoffeeScript 1.3.3
(function() {
  var XMLBuilder;

  XMLBuilder = require('./XMLBuilder');

  module.exports.create = function(name, xmldec, doctype, options) {
    if (name != null) {
      return new XMLBuilder(name, xmldec, doctype, options).root();
    } else {
      return new XMLBuilder();
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/xmlbuilder/lib/index.js
// module id = 76
// module chunks = 0 1